export default __webpack_public_path__ + "f443eeffe23a5a6effc3e358e24bf58e.png";